import { ReactComponent as EyeOpenIcon } from "../../../assets/icons/eye-open.svg";
import { ReactComponent as EyeCloseIcon } from "../../../assets/icons/eye-close.svg";
import { useState } from "react";

const PasswordField = ({ placeholder, className, setState }) => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    const toggle = () => setPasswordVisible((s) => !s);
    return (
        <div className="position-relative">
            <input
                onChange={(e) => setState(e.target.value)}
                style={{ height: "3rem" }}
                type={passwordVisible ? "text" : "password"}
                placeholder={placeholder}
                className={className}
                required
            />
            <div style={{top:"50%",transform:"translateY(-50%)"}} className="position-absolute me-2 end-0 cursor-pointer" onClick={toggle}>{passwordVisible ? <EyeCloseIcon /> : <EyeOpenIcon />}</div>
        </div>
    );
};

export default PasswordField;
